var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property, query, state } from 'lit/decorators.js';
import { isNil } from 'lodash-es';
let SdsClippedTextBase = (() => {
    var _a, _SdsClippedTextBase_text_accessor_storage, _SdsClippedTextBase_href_accessor_storage, _SdsClippedTextBase_basic_accessor_storage, _SdsClippedTextBase_lines_accessor_storage, _SdsClippedTextBase_hasOverflow_accessor_storage, _SdsClippedTextBase__textElement_accessor_storage, _SdsClippedTextBase__overflowIndicator_accessor_storage;
    let _classSuper = LitElement;
    let _text_decorators;
    let _text_initializers = [];
    let _text_extraInitializers = [];
    let _href_decorators;
    let _href_initializers = [];
    let _href_extraInitializers = [];
    let _basic_decorators;
    let _basic_initializers = [];
    let _basic_extraInitializers = [];
    let _lines_decorators;
    let _lines_initializers = [];
    let _lines_extraInitializers = [];
    let _hasOverflow_decorators;
    let _hasOverflow_initializers = [];
    let _hasOverflow_extraInitializers = [];
    let __textElement_decorators;
    let __textElement_initializers = [];
    let __textElement_extraInitializers = [];
    let __overflowIndicator_decorators;
    let __overflowIndicator_initializers = [];
    let __overflowIndicator_extraInitializers = [];
    return _a = class SdsClippedTextBase extends _classSuper {
            constructor() {
                super(...arguments);
                _SdsClippedTextBase_text_accessor_storage.set(this, __runInitializers(this, _text_initializers, ''));
                _SdsClippedTextBase_href_accessor_storage.set(this, (__runInitializers(this, _text_extraInitializers), __runInitializers(this, _href_initializers, undefined)));
                _SdsClippedTextBase_basic_accessor_storage.set(this, (__runInitializers(this, _href_extraInitializers), __runInitializers(this, _basic_initializers, false)));
                _SdsClippedTextBase_lines_accessor_storage.set(this, (__runInitializers(this, _basic_extraInitializers), __runInitializers(this, _lines_initializers, 1)));
                _SdsClippedTextBase_hasOverflow_accessor_storage.set(this, (__runInitializers(this, _lines_extraInitializers), __runInitializers(this, _hasOverflow_initializers, false)));
                _SdsClippedTextBase__textElement_accessor_storage.set(this, (__runInitializers(this, _hasOverflow_extraInitializers), __runInitializers(this, __textElement_initializers, void 0)));
                _SdsClippedTextBase__overflowIndicator_accessor_storage.set(this, (__runInitializers(this, __textElement_extraInitializers), __runInitializers(this, __overflowIndicator_initializers, void 0)));
                this._intersectionObserver = __runInitializers(this, __overflowIndicator_extraInitializers);
                this.handleIntersection = (entries) => {
                    this.hasOverflow = !entries[0].isIntersecting;
                };
            }
            /**
             * Represents the text to be displayed and potentially clipped.
             *
             * Defaults to '' (empty string)
             *
             * @type {String}
             */
            get text() { return __classPrivateFieldGet(this, _SdsClippedTextBase_text_accessor_storage, "f"); }
            set text(value) { __classPrivateFieldSet(this, _SdsClippedTextBase_text_accessor_storage, value, "f"); }
            /**
             * Specifies a hyperlink for the clipped text. When set, the clipped text becomes a clickable link,
             * navigating to the provided URL.
             *
             * Defaults to `undefined`
             *
             * @attr {string} href - The URL to navigate to when the clipped text is clicked.
             */
            get href() { return __classPrivateFieldGet(this, _SdsClippedTextBase_href_accessor_storage, "f"); }
            set href(value) { __classPrivateFieldSet(this, _SdsClippedTextBase_href_accessor_storage, value, "f"); }
            /**
             * Specifies if this popover is basic.
             * @attr {boolean} basic - True if this popover is basic
             */
            get basic() { return __classPrivateFieldGet(this, _SdsClippedTextBase_basic_accessor_storage, "f"); }
            set basic(value) { __classPrivateFieldSet(this, _SdsClippedTextBase_basic_accessor_storage, value, "f"); }
            /**
             * Specifies how many lines should be displayed before clipping.
             * @attr {number} lines - The number of lines to display before clipping.
             */
            get lines() { return __classPrivateFieldGet(this, _SdsClippedTextBase_lines_accessor_storage, "f"); }
            set lines(value) { __classPrivateFieldSet(this, _SdsClippedTextBase_lines_accessor_storage, value, "f"); }
            get hasOverflow() { return __classPrivateFieldGet(this, _SdsClippedTextBase_hasOverflow_accessor_storage, "f"); }
            set hasOverflow(value) { __classPrivateFieldSet(this, _SdsClippedTextBase_hasOverflow_accessor_storage, value, "f"); }
            get _textElement() { return __classPrivateFieldGet(this, _SdsClippedTextBase__textElement_accessor_storage, "f"); }
            set _textElement(value) { __classPrivateFieldSet(this, _SdsClippedTextBase__textElement_accessor_storage, value, "f"); }
            get _overflowIndicator() { return __classPrivateFieldGet(this, _SdsClippedTextBase__overflowIndicator_accessor_storage, "f"); }
            set _overflowIndicator(value) { __classPrivateFieldSet(this, _SdsClippedTextBase__overflowIndicator_accessor_storage, value, "f"); }
            async connectedCallback() {
                super.connectedCallback();
                await this.updateComplete;
                this.observeOverflowIndicator();
            }
            disconnectedCallback() {
                super.disconnectedCallback();
                this.unobserveOverflowIndicator();
            }
            updated(changedProperties) {
                if (this.lines > 1) {
                    this.style.setProperty('--lines', this.lines.toString());
                }
                if (changedProperties.has('hasOverflow')) {
                    this.observeOverflowIndicator();
                }
            }
            observeOverflowIndicator() {
                if (!isNil(this._overflowIndicator)) {
                    if (!isNil(this._intersectionObserver)) {
                        this.unobserveOverflowIndicator();
                        console.debug('overflowIndicator is already observed, unobserving...');
                    }
                    this._intersectionObserver = new IntersectionObserver(this.handleIntersection, {
                        root: this._textElement,
                    });
                    this._intersectionObserver.observe(this._overflowIndicator);
                }
                else {
                    console.debug('overflowIndicator is undefined and cannot be observed, popover will not work');
                }
            }
            unobserveOverflowIndicator() {
                var _b;
                (_b = this._intersectionObserver) === null || _b === void 0 ? void 0 : _b.disconnect();
                this._intersectionObserver = undefined;
            }
            renderContent() {
                var _b;
                const slotContainerElement = this.querySelector('[slot="container"]');
                const hasSlotContent = (_b = slotContainerElement === null || slotContainerElement === void 0 ? void 0 : slotContainerElement.textContent) === null || _b === void 0 ? void 0 : _b.trim();
                if (hasSlotContent) {
                    // The slot 'container' is needed for cases where the clipped component's text includes HTML tags (e.g., <span>),
                    // such as in a combobox when highlighting text during a search.
                    return html `<slot name="container"></slot>`;
                }
                else {
                    if (this.href !== undefined) {
                        return html `<a href="${this.href}" part="sds-clipped-link">${this.text}</a>`;
                    }
                    else {
                        return html `${this.text}`;
                    }
                }
            }
        },
        _SdsClippedTextBase_text_accessor_storage = new WeakMap(),
        _SdsClippedTextBase_href_accessor_storage = new WeakMap(),
        _SdsClippedTextBase_basic_accessor_storage = new WeakMap(),
        _SdsClippedTextBase_lines_accessor_storage = new WeakMap(),
        _SdsClippedTextBase_hasOverflow_accessor_storage = new WeakMap(),
        _SdsClippedTextBase__textElement_accessor_storage = new WeakMap(),
        _SdsClippedTextBase__overflowIndicator_accessor_storage = new WeakMap(),
        (() => {
            var _b;
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
            _text_decorators = [property({ type: String })];
            _href_decorators = [property({ type: String })];
            _basic_decorators = [property({ type: Boolean })];
            _lines_decorators = [property({ type: Number })];
            _hasOverflow_decorators = [state()];
            __textElement_decorators = [query('[data-id="text-container"]')];
            __overflowIndicator_decorators = [query('[data-id="overflow-indicator"]')];
            __esDecorate(_a, null, _text_decorators, { kind: "accessor", name: "text", static: false, private: false, access: { has: obj => "text" in obj, get: obj => obj.text, set: (obj, value) => { obj.text = value; } }, metadata: _metadata }, _text_initializers, _text_extraInitializers);
            __esDecorate(_a, null, _href_decorators, { kind: "accessor", name: "href", static: false, private: false, access: { has: obj => "href" in obj, get: obj => obj.href, set: (obj, value) => { obj.href = value; } }, metadata: _metadata }, _href_initializers, _href_extraInitializers);
            __esDecorate(_a, null, _basic_decorators, { kind: "accessor", name: "basic", static: false, private: false, access: { has: obj => "basic" in obj, get: obj => obj.basic, set: (obj, value) => { obj.basic = value; } }, metadata: _metadata }, _basic_initializers, _basic_extraInitializers);
            __esDecorate(_a, null, _lines_decorators, { kind: "accessor", name: "lines", static: false, private: false, access: { has: obj => "lines" in obj, get: obj => obj.lines, set: (obj, value) => { obj.lines = value; } }, metadata: _metadata }, _lines_initializers, _lines_extraInitializers);
            __esDecorate(_a, null, _hasOverflow_decorators, { kind: "accessor", name: "hasOverflow", static: false, private: false, access: { has: obj => "hasOverflow" in obj, get: obj => obj.hasOverflow, set: (obj, value) => { obj.hasOverflow = value; } }, metadata: _metadata }, _hasOverflow_initializers, _hasOverflow_extraInitializers);
            __esDecorate(_a, null, __textElement_decorators, { kind: "accessor", name: "_textElement", static: false, private: false, access: { has: obj => "_textElement" in obj, get: obj => obj._textElement, set: (obj, value) => { obj._textElement = value; } }, metadata: _metadata }, __textElement_initializers, __textElement_extraInitializers);
            __esDecorate(_a, null, __overflowIndicator_decorators, { kind: "accessor", name: "_overflowIndicator", static: false, private: false, access: { has: obj => "_overflowIndicator" in obj, get: obj => obj._overflowIndicator, set: (obj, value) => { obj._overflowIndicator = value; } }, metadata: _metadata }, __overflowIndicator_initializers, __overflowIndicator_extraInitializers);
            if (_metadata) Object.defineProperty(_a, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
        })(),
        _a;
})();
export { SdsClippedTextBase };
